import React from 'react';
import { BackgroundErrorPanel } from '../BackgroundErrorPanel';
import bgImage from '@/assets/images/background.jpg';

export const NotFoundComponent = () => {
  return (
    <BackgroundErrorPanel
      title="Oops!"
      message={
        <>
          We are sorry, but the page you requested is temporarily unavailable.
          Please try again later.
        </>
      }
      imageSrc={bgImage}
      altText="Not Found"
      backgroundBoxStyles={{
        position: 'absolute',
        top: '60%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        height: { xs: '30%', sm: '40%', md: '50%' },
      }}
      contentBoxStyles={{
        position: 'absolute',
        top: '60%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        padding: { xs: '20px', sm: '30px', md: '50px' },
        textAlign: 'center',
        maxWidth: { xs: '80%', sm: '60%', md: '30%' },
        maxHeight: 'auto',
        overflow: 'hidden',
      }}
    />
  );
};
